import React from "react";
import { Link } from "react-router-dom";
import { COMPANY_DETAILS, POLICY_LAST_UPDATED } from "./policyData";

const PolicyPageLayout = ({
  title,
  subtitle,
  children,
  lastUpdated = POLICY_LAST_UPDATED,
}) => {
  return (
    <div className="min-h-screen px-4 py-12">
      <div className="mx-auto mb-6 max-w-6xl px-4">
        <div className="relative flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3 text-sm text-gray-600">
            <button
              onClick={() => window.history.back()}
              className="flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 transition hover:bg-gray-100"
              aria-label="Go back"
            >
              &larr;
            </button>

            <span className="flex flex-wrap items-center gap-1">
              <Link to="/" className="hover:underline">
                Home
              </Link>
              <span>/</span>
              <span className="font-medium text-gray-800">{title}</span>
            </span>
          </div>

          <h1 className="text-center text-2xl font-bold text-[#351F72] sm:text-3xl md:absolute md:left-1/2 md:-translate-x-1/2 md:text-4xl">
            {title}
          </h1>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4">
        <div className="rounded-3xl border border-[#351F72]/10 bg-white p-6 shadow-sm sm:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#F3802C]">
              Last updated {lastUpdated}
            </p>
            <p className="mt-3 text-sm leading-7 text-gray-700 sm:text-base">
              {subtitle}
            </p>
          </div>

          <div className="mt-8 space-y-8">{children}</div>

          <div className="mt-10 rounded-2xl bg-[#f8f6ff] p-5">
            <h2 className="text-lg font-bold text-[#351F72]">Need help?</h2>
            <p className="mt-2 text-sm leading-7 text-gray-700 sm:text-base">
              You can contact {COMPANY_DETAILS.name} at{" "}
              <a href={COMPANY_DETAILS.emailHref} className="font-medium text-[#351F72] hover:underline">
                {COMPANY_DETAILS.email}
              </a>{" "}
              or{" "}
              <a href={COMPANY_DETAILS.phoneHref} className="font-medium text-[#351F72] hover:underline">
                {COMPANY_DETAILS.phone}
              </a>
              . Support hours: {COMPANY_DETAILS.supportHours}.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PolicySection = ({ title, children }) => {
  return (
    <section className="space-y-3 border-b border-gray-100 pb-8 last:border-b-0 last:pb-0">
      <h2 className="text-xl font-bold leading-snug text-[#351F72]">{title}</h2>
      <div className="space-y-3 text-sm leading-7 text-gray-800 sm:text-base">
        {children}
      </div>
    </section>
  );
};

export const PolicyList = ({ items }) => {
  return (
    <ul className="list-disc space-y-2 pl-5">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
};

export default PolicyPageLayout;
